import { store } from '../store/store'

const MAX_FILESIZE = 6291456 // 6mb in bytes

export async function uploadSmoster(file, uploadUrl) {
  const uploadStartTimestamp = Date.now()
  store.commit('setLatestSmosterUploadStarted', uploadStartTimestamp)

  try {
    if (!isBelowMaxFileSize(file)) {
      throw new Error(
        `file size of ${file.size} is exceeding the max file size of ${MAX_FILESIZE}`
      )
    }

    const formdata = new FormData()
    formdata.append('file', file, file.name)
    const uploadCall = await fetch(uploadUrl, {
      method: 'POST',
      body: formdata,
    })

    if (!uploadCall.ok) {
      throw new Error(
        `Upload of smoster file (${uploadCall.url}) failed with code ${uploadCall.status}. Are you talking to the correct backend?`
      )
    }

    const smoster = await (await uploadCall).json()

    // only set the smosterId if there has not been a new upload call started in the time it took this call to finish
    if (store.state.latestSmosterUploadStarted === uploadStartTimestamp) {
      store.commit('setSmosterId', smoster.id)
    } else {
      console.log('SmosterId not set, since another upload had started')
    }

    return Promise.resolve
  } catch (e) {
    return Promise.reject(e)
  }
}

export function isBelowMaxFileSize(file) {
  return file.size <= MAX_FILESIZE
}
